const path = {
    HOME_PREFIX: '/',
    SKILLS_PREFIX: '/skills',
    WORKS_PREFIX: '/projects',
    CONTACT_PREFIX: '/contact',
    FRONTEND_PREFIX: '/frontend',
    BACKEND_PREFIX: '/backend',
    AI_PREFIX: '/ai',
    OVERVIEW_PREFIX: '/overview',
}

export default path;